<div
    class="selectbox width-100"
    [ngClass]="[
      isOpen ? 'is-open has-focus' : '',
      !margin ? 'no-margin' : '',
      isActive() ? 'is-active' : '',
      readOnly ? 'read-only' : '',
      isRequired ? 'is-required' : '',
      styles.wrapper,
      disabled ? 'disabled' : '',
      isInvalid ? 'is-invalid' : '']"
    [attr.data-test]="'selectbox-' + inputName"
    (mousedown)="onClick($event)"
    (click)="showOptions($event)">
  <div class="selectbox__select">{{ selectedOptionLabel | translate }}</div>
  <div class="menu selectbox__option-list">
    @if (search) {
      <div class="selectbox__search" #searchInput>
        <input
            type="text"
            [value]="searchText" (input)="updateSearch($event)"
            [attr.data-test]="'input-search'"
            [placeholder]="searchPlaceholder">
        <label class="search__icon">
          <span class="icon-search"></span>
        </label>
      </div>
    }
    <div class="option-list__all" [attr.data-test]="'selectbox-' + inputName + '-options'">
      @for (option of options | selectBoxFilter:searchText; track option[optionLabelKey]) {
        <div
            class="menu__item selectbox__option"
            [ngClass]="{'disabled': option?.disabled}"
            (click)="selectOption(option)"
            [attr.data-test]="'selectbox-' + option[optionLabelKey]">
          {{ option[optionLabelKey] | translate }}
        </div>
      }
    </div>
  </div>
  @if (showPlaceholder()) {
    <div class="selectbox__label">{{ getLabel() }}</div>
  }
  @if (form) {
    <div [formGroup]="form">
      <input formControlName="{{ inputName }}" [value]="modelValue" [name]="inputName" hidden [required]="isRequired">
    </div>
  }
  @if (loading) {
    <div class="selectbox__loader">
      <div class="loading-animation"></div>
    </div>
  }
</div>
